module.exports = __webpack_public_path__ + "static/media/twelve_monkeys_kitchen.d2c985a2.gif";